import React from 'react';
import PropTypes from 'prop-types';
import { UploadFile as UploadFileIcon } from '@mui/icons-material';

import FileDropZone from '../../../../components/FileDropZone';
import texts from '../texts.json';
import { DropZoneBox, DropTitle, DropSubtitle } from '../styles';

// The extension and both MIME types browsers report for a ZIP; the queue re-checks by extension.
const ZIP_ACCEPT = '.zip,application/zip,application/x-zip-compressed';

const UploadDropZone = ({ onFiles }) => (
  <FileDropZone accept={ZIP_ACCEPT} multiple inputLabel={texts.dropInputLabel} onFiles={onFiles}>
    {({ isDragging, dropzoneProps, open }) => (
      <DropZoneBox
        $dragging={isDragging}
        onClick={open}
        role="button"
        {...dropzoneProps}
      >
        <UploadFileIcon />
        <DropTitle>{texts.dropTitle}</DropTitle>
        <DropSubtitle>{texts.dropSubtitle}</DropSubtitle>
      </DropZoneBox>
    )}
  </FileDropZone>
);

UploadDropZone.propTypes = {
  onFiles: PropTypes.func.isRequired,
};

export default UploadDropZone;
